<template>
  <v-container>
    <h1 class="text-center">STOCK ROOM</h1>
    <v-btn text @click="addItemTostock">ADD STOCK ITEM</v-btn>
    <v-data-table
      :headers="headers"
      :items="STOCK_DATA.items"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.bought_rate="{ item }">
        <p>{{ item.bought_rate |rupee }}</p>
      </template>
      <template v-slot:item.id="{ item }">
        <v-btn icon @click="removeStockItem(item)" color="error">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.timestamp="{ item }">{{item.timestamp | date}}</template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "Product Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Category",
          align: "start",
          sortable: true,
          value: "category",
        },
        {
          text: "MRP",
          align: "start",
          sortable: true,
          value: "mrp",
        },
        {
          text: "Stock",
          align: "start",
          sortable: true,
          value: "stock",
        },
        {
          text: "Bought Rate",
          align: "start",
          sortable: true,
          value: "bought_rate",
        },
        {
          text: "ON",
          align: "start",
          sortable: true,
          value: "timestamp",
        },
        {
          text: "ACTION",
          align: "start",
          sortable: true,
          value: "id",
        },
      ],
    };
  },
  created() {
    this.$store.commit("SET_LOADING", true);
    this.GET_MRPS_STOCK({ id: this.$route.params.id }).then(() => {
      this.$store.commit("SET_LOADING", false);
    });
  },
  computed: {
    ...mapGetters(["STOCK_DATA"]),
  },
  methods: {
    ...mapActions(["GET_MRPS_STOCK", "REMOVE_STOCK_ITEMS_UPDATE"]),
    addItemTostock() {
      if (this.STOCK_DATA.stock != undefined) {
        this.$router.replace({
          name: "STOREROOM_UPDATE",
          params: {
            id: this.STOCK_DATA.stock.vendor,
            uid: this.$route.params.id,
          },
        });
      }
    },
    removeStockItem(item) {
      this.$store.commit("SET_LOADING", true);
      this.REMOVE_STOCK_ITEMS_UPDATE({ iid: item.id }).then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
  },
};
</script>

<style>
</style>